import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'
import { StyledTableCell } from './TableCell'
import { StyledTableRow } from './TableRow'

const StyledTableHead = styled.thead`
  font-family: Exo;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
  border-bottom: 1px solid ${colors.secondary70};
  ${props => props.withTopBorder && css`
    border-top: 1px solid ${colors.secondary90};
  `}

  ${StyledTableRow} {
    height: auto;
  }

  ${StyledTableCell} {
    color: ${colors.secondary60};
    padding: 7px 12px 6px 12px;
    vertical-align: bottom;
    letter-spacing: 0.3px;
    font-size: 10px;
    height: auto;
  }
`

const TableHead = ({ withTopBorder, children }) => {
  return (
    <StyledTableHead
      withTopBorder={withTopBorder}
    >
      {children}
    </StyledTableHead>
  )
}

TableHead.propTypes = {
  withTopBorder: PropTypes.bool,
  children: PropTypes.node,
}

export default TableHead
